import {Injectable, InjectionToken} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {HttpsUrl, KlientId, Signeringsmetode} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

const debug = initDebugger('Appkonfigurasjon');

/**
 * Tjeneste som eksponeres statisk konfigurasjonsinformasjon.
 *
 * Erstatter ajs sin src/scripts/felles/infrastruktur/Konfigurasjon.ts
 */
@Injectable({providedIn: 'root'})
export class Appkonfigurasjon {

    /** Navn på lastet konfigurasjon (test/e2etest/preprod/prod) */
    public readonly miljø: Miljø;
    /** rot-url til api-endepunktet */
    public readonly serviceRotUrl: HttpsUrl;
    /** Maks størrelse på avatar/gruppe logo ved opplasting */
    public readonly maksAvatarStørrelse: number;
    /** Maks størrelse på fil ved opplasting til arkiv/sak */
    public readonly maksFilopplastingStørrelse: number;
    /** signeringsmetoder av typen "avansert elektronisk" tilgjengelig for bruker ved signering av dokument */
    public readonly tilgjengeligeSigneringsmetoderAvansertElektronisk: Signeringsmetode[];
    /** Identifiserer denne klienten (nettleser-arkfanen feks) og gjør det feks mulig å identifisere hvorvidt en modelloppdatering-pushmelding stammer fra denne klienten. */
    public readonly klientId: KlientId;

    static fraAjsKonfigurasjon(ajsKonfigurasjon: Konfigurasjon) {
        return new Appkonfigurasjon({
            miljø: ajsKonfigurasjon.miljø as Miljø,
            serviceRotUrl: ajsKonfigurasjon.serviceRotUrl,
            maksAvatarStørrelse: ajsKonfigurasjon.maksAvatarStørrelse,
            maksFilopplastingStørrelse: ajsKonfigurasjon.maksFilstørrelse,
            tilgjengeligeSigneringsmetoderAvansertElektronisk: ajsKonfigurasjon.tilgjengeligeSigneringsmetoderAvansertElektronisk,
            klientId: ajsKonfigurasjon.klientId
        });
    }

    constructor(konfig: Partial<Appkonfigurasjon> = {}) {
        this.miljø = konfig.miljø ?? Miljø.test;
        this.serviceRotUrl = konfig.serviceRotUrl ?? '';
        this.maksAvatarStørrelse = konfig.maksAvatarStørrelse ?? 0;
        this.maksFilopplastingStørrelse = konfig.maksFilopplastingStørrelse ?? 0;
        this.tilgjengeligeSigneringsmetoderAvansertElektronisk = konfig.tilgjengeligeSigneringsmetoderAvansertElektronisk ?? [];
        this.klientId = konfig.klientId ?? '';
    }

}

/** DI token som aktivt {@link Miljø} kan leses fra.
 * Gir tilgang til samme verdi som eksponert via Appkonfigurasjon.miljø */
export const MILJØ: InjectionToken<Miljø> = new InjectionToken<Miljø>('Miljø konstant');

//DI hjelpemetoder

/** Initialiserer ng2 {@link Appkonfigurasjon} fra tilsvarende ajs instans {@link Konfigurasjon} */
export function appKonfigurasjonProviderInitialisertFraAjs() {
    return {
        provide: Appkonfigurasjon,
        useFactory: (ajsKonfigurasjon: Konfigurasjon) => Appkonfigurasjon.fraAjsKonfigurasjon(ajsKonfigurasjon),
        deps: [Konfigurasjon]
    };
}

/** Binder {@link Appkonfigurasjon#miljø} til DI tokenet {@link MILJØ} */
export function MILJØProvider() {
    return {
        provide: MILJØ,
        useFactory: (konfigurasjon: Appkonfigurasjon) => konfigurasjon.miljø,
        deps: [Appkonfigurasjon]
    };
}


export enum Miljø {
    enhetstest = 'enhetstest',
    test = 'test',
    e2etest = 'e2etest',
    testhttps = 'testhttps',
    preprod = 'preprod',
    prod = 'prod',
}
